import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ArticoliService} from "../../../_services/articoli.service";
import {ArticoloEsolver} from "../../../_models/ArticoloEsolver";
import {OrganizzazioniService} from "../../../_services/organizzazioni.service";
import {SaveMessage} from "../../../_helpers/save-message";

@Component({
    selector: 'app-articolo-input',
    templateUrl: './articolo-input.component.html',
    styleUrls: ['./articolo-input.component.scss'],
    standalone: false
})
export class ArticoloInputComponent  {
  @Input() codArt = "";
  @Output() codArtChange = new EventEmitter<string>();
  // Estensione non-breaking (feature 052 / C7): notifica il testo digitato dall'utente
  // senza implicare una selezione valida dal catalogo. `codArtChange` resta emesso
  // esclusivamente su selezione da lista, quindi i consumer esistenti non cambiano comportamento.
  @Output() codArtTyped = new EventEmitter<string>();
  @Output() articoloSelect = new EventEmitter<ArticoloEsolver>();
  articoli: ArticoloEsolver[] = [];
  page = 0;
  count = 50;
  loading = false;
  showList = false;
  constructor(
    private saveMessage: SaveMessage,
    private organizzazioneService: OrganizzazioniService,
    private articoliService: ArticoliService) { }
  
  // Emessa su digitazione (ionChange = commit utente): propaga il testo digitato e avvia la ricerca.
  onCodArtInput() {
    this.codArtTyped.emit(this.codArt);
    this.getArticoli(true);
  }

  getArticoli(isSearch: boolean) {
    this.showList = isSearch ? true : !this.showList;
    if (!this.showList) {
      this.articoli = [];
      this.codArt = '';
      return false;
    }
    this.loading = true;
    this.articoliService.searchArticoli(this.organizzazioneService.organizzazioneId, this.codArt, this.page, this.count)
      .then(response => this.articoli = response.result)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento degli articoli."))
      .finally(() => this.loading = false);
  }

  selectArticolo = (articolo: ArticoloEsolver) => {
    this.codArt = articolo.codArt;
    this.codArtChange.emit(articolo.codArt);
    this.articoloSelect.emit(articolo);
    this.getArticoli(false);
  };
}
